export const unitPreferenceList = [
	{ value: 'GB', label: 'Gigabytes (GB)' },
	{ value: 'TB', label: 'Terabytes (TB)' },
	{ value: 'PB', label: 'Petabytes (PB)' },
];

// const collectionDeviceCols = [
// 	{
// 		field: "",
// 		flex: .5,
// 		minWidth: 25,
// 		headerName: "Select",
// 		resizable: true,
// 		sortable: true,
// 		cellRenderer: 'checkboxFormatter'
// 	},
// 	{
// 		field: "device_type_description",
// 		flex: 1,
// 		minWidth: 100,
// 		headerName: "Device Type",
// 		resizable: true,
// 		sortable: true
// 	},
// 	{
// 		field: "ip_address",
// 		flex: 1,
// 		minWidth: 100,
// 		maxWidth: 200,
// 		headerName: "IP Address/DNS Entry",
// 		cellStyle: { textAlign: "center" },
// 		resizable: true,
// 		sortable: true,
// 		cellRenderer: 'ipAddressFormatter'
// 	},
// 	{
// 		field: "id",
// 		flex: 1,
// 		minWidth: 100,
// 		maxWidth: 200,
// 		headerName: "ID",
// 		cellStyle: { textAlign: "center" },
// 		resizable: true,
// 		sortable: true
// 	},
// 	{
// 		field: "device_alias",
// 		flex: 1,
// 		minWidth: 100,
// 		headerName: "Device Alias",
// 		sortable: true,
// 		resizable: true
// 	},
// 	{
// 		field: "collection_day",
// 		width: 160,
// 		headerName: "Collection Day(s)",
// 		sortable: true,
// 		resizable: true,
// 		cellStyle: { textAlign: "center" },
// 		cellRenderer: 'formatCollectionDay'
// 	},
// 	{
// 		field: "collection_time",
// 		width: 120,
// 		headerName: "Collection Time",
// 		sortable: true,
// 		resizable: true,
// 		cellStyle: { textAlign: "center" }
// 	},
// 	{
// 		field: "site_code",
// 		flex: 1,
// 		minWidth: 100,
// 		headerName: "Site Code",
// 		sortable: true,
// 		resizable: true
// 	},
// 	{
// 		field: 'password',
// 		width: 140,
// 		headerName: 'Password Removed',
// 		cellRenderer: 'booleanFormatter',
// 		resizable: true,
// 		sortable: true
// 	},
// 	{
// 		field: "enabled",
// 		headerName: "Enabled",
// 		width: 90,
// 		resizable: true,
// 		sortable: true,
// 		cellRenderer: 'booleanFormatter'
// 	},
// ];

export const autobotDateOptions = [
	{
		value: 0,
		label: "Monday"
	},
	{
		value: 1,
		label: "Tuesday"
	},
	{
		value: 2,
		label: "Wednesday"
	},
	{
		value: 3,
		label: "Thursday"
	},
	{
		value: 4,
		label: "Friday"
	},
	{
		value: 5,
		label: 'Saturday'
	},
	{
		value: 6,
		label: 'Sunday'
	}
];

// the permissions need to match the User model in arbiter for roles:
// enum: ["super_user", "super_user_read_only", "local_admin", "basic_user"],
export const roles = [
	{
		value: "basic_user",
		label: 'Basic User',
	},
	{
		value: "local_admin",
		label: 'Local Administrator',
	},
	{
		value: "super_user_read_only",
		label: 'Super User (Read Only)',
	},
	{
		value: "super_user",
		label: 'Super User',
	},
];

export const allPerformanceTypes = [
	{ value: 'iops', label: 'IOPS', route: 'device_performance_all_iops_latency_trend'},
	{ value: 'latency', label: 'Latency', route: 'device_performance_all_iops_latency_trend'},
	// { value: 'avg_write_latency', label: 'Write Latency', route: 'device_performance_all_iops_latency_trend'},
	{ value: 'mbsec', label: 'MB/Sec', route: 'device_performance_all_iops_latency_trend'},
];

export const allSpaceTypes = [
	{ value: 'free', label: 'Free' },
	{ value: 'used', label: 'Used' },
	{ value: 'percent_used', label: '% Used' },
	{ value: 'allocated', label: 'Allocated', },
	{ value: 'capacity', label: 'Capacity', },
	{ value: 'orphaned', label: 'Orphaned', },
	{ value: 'snap', label: 'Snap', },
];
export const allBUSpaceTypes = [
	{ value: 'free', label: 'Free' },
	{ value: 'used', label: 'Used' },
	{ value: 'percent_used', label: '% Used' },
	{ value: 'allocated', label: 'Allocated' }
];
export const allPhysSpaceTypes = [
	{ value: 'physical_used', label: 'Physical Used', },
	{ value: 'physical_free', label: 'Physical Free',},
	{ value: 'allocated', label: 'Allocated', },
	{ value: 'physical_capacity', label: 'Physical Capacity',},
	{ value: 'orphaned', label: 'Orphaned', },
	{ value: 'snap', label: 'Snap', },
];

export const chartTypes = [
	{ value: 'capacity', label: 'Capacity', route: 'capacity'},
	{ value: 'phys_capacity', label: 'Physical Capacity', route: 'capacity'},
	{ value: 'performance', label: 'Performance', route: 'performance'},
	{ value: 'data_reduction', label: 'Data Reduction Ratio', route: 'data_reduction'}
];

export const chartBUTypes = [
	{ value: 'capacity', label: 'Capacity Used', route: 'capacity'},
	{ value: 'capacity_cost', label: 'Capacity Cost', route: 'capacity'},
	{ value: 'cpu', label: 'CPU', route: 'cpu'},
	{ value: 'cost_per_cpu', label: 'CPU Cost', route: 'cpu'},
	{ value: 'memory', label: 'Memory', route: 'memory'},
	{ value: 'cost_per_memory', label: 'Memory Cost', route: 'memory'},
	{ value: 'total_cost', label: 'Total Cost', route: 'cost'}
];

export const hostImage = "data:image/png;base64,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";
export const storageDeviceImage = "data:image/png;base64,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";
export const portImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEfSURBVDhPrZVBjsIwDADbXdgP9c6ZD/QFe+Y1nPcF/cCeufdBgIDNWHbkuIkqVh0J4tjp1C4g+p/z+dVtiQnHcfyURCLFXxoKwzDsNSxi8GfFxdsWMhy4ZOTv06knad2+y+/lspum6ZE7JBllPm+d1c5aZ8SsH5psjgnzPN81XIxJZ7oVRJiSN9klkJkgisHORlm+kW/XC6IsdpYWee6wGNnwncUxK52JxN8IRBg7W5E9pZDwNUOE/+3My6izVkeGhkyIMrD6YmSoyFpj9tQ1FlZ/KVYDZMfD4arbDGdyzUtIaiid1WqWo84KRc0diN8zgbp/pVQxpr9O6ry1ZOBr0JJBFureDhfPTENodgZ8sIXQH4Z4wZqMFdfGfwFd9wehZBJ8EXNdiAAAAABJRU5ErkJggg==";

export const ipReg = /^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/g;
export const dnsReg = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-\_]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/g;
export const DrrDefaultValue = "1.0"

export const auth0Client = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? "7U23wnl1sLDKyzyNa185f0fNAFT44dOG" : "D7OYZIQwhyuBMSxjRL5M5gdLdk9FDLTJ";

export const indexedDbMaxAgeMs = 24 * 60 * 60 * 1000;